import React from 'react';
import { XIcon } from 'lucide-react';
const PROBLEMS = ['You arrive at the studio without a complete class plan.', 'You spend hours preparing before every session.', 'You constantly search online for new sequences and ideas.', 'Your resources are scattered across notebooks, screenshots, PDFs, and saved posts.', 'You struggle to adapt one class for different experience levels.', 'Your classes sometimes feel improvised instead of professionally structured.'];
export function Problems() {
  return <section aria-labelledby="problems-title" className="w-full bg-white px-4 py-10 sm:px-6" data-id="element-178" data-mp="2o487te3nak2b">
      <div className="mx-auto max-w-4xl text-center" data-id="element-179" data-mp="2j783p8qcvrdu">
        <span className="font-head text-[11px] font-bold uppercase tracking-wider text-urgent sm:text-xs" data-id="element-180" data-mp="2j7zxce0e7f1h">
          The Teaching Reality
        </span>
        <h2 id="problems-title" className="mt-2 font-head text-2xl font-extrabold uppercase leading-tight text-charcoal sm:text-3xl" data-id="element-181" data-mp="hdilwkxhlzbl">
          If you teach yoga, you probably know these problems.
        </h2>

        <ul className="mx-auto mt-5 grid gap-2 text-left sm:grid-cols-2" data-id="element-182" data-mp="34t7q3bztnr3v">
          {PROBLEMS.map(item => <li key={item} className="flex items-start gap-2 rounded-xl border border-urgent/20 bg-urgent/5 px-3 py-2.5 text-sm leading-snug text-charcoal" data-id="element-183" data-mp="2vq6o9nhzom60">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-urgent" aria-hidden="true" data-id="element-184" data-mp="3nhct2h8nn81m" />
              {item}
            </li>)}
        </ul>

        <p className="mt-6 font-head text-base font-bold uppercase leading-tight text-brand-dark sm:text-xl" data-id="element-185" data-mp="3sfxqya0fpfmw">
          How many more classes do you want to keep building from scratch?
        </p>
      </div>
    </section>;
}